import React from "react";
import work1 from '../../images/Cozypages.png';
import ResizableImage from "./ResizableImage";


export default function Project2() {
  return (
    <div className="project_column_div">
      <a
        href="https://play.google.com/store/apps/details?id=com.ennovify.cozy_pages&pcampaignid=web_share" // Replace with your desired link
        target="_blank"
        rel="noopener noreferrer"
        onClick={(e) => {
          e.stopPropagation(); // Prevents the link click from triggering the modal
        }}
      >
      <ResizableImage
        src={work1}
        alt="A computer and mobile"
      /></a>
      <div className="say_hello & project_name">
      Cozy Pages: A journalling App.
      </div>
    </div>
  );
}
